import Phaser from 'phaser';
import { loadPrefs } from '../storage.js';
import { net, GameNet, Rest } from '../net.js';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  create(): void {
    void this.route();
  }

  /**
   * If this tab has a fresh reconnection token (page was reloaded or the
   * browser dropped us mid-match), resume the seat directly into the game —
   * the server holds it for 300s. Otherwise fall through to the lobby.
   */
  private async route(): Promise<void> {
    await loadPrefs();
    const token = GameNet.storedReconnectToken();
    if (token) {
      try {
        await net.reconnect(token);
        const splash = document.getElementById('splash');
        if (splash) {
          splash.classList.add('hide');
          setTimeout(() => splash.remove(), 600);
        }
        this.scene.start('GameScene');
        return;
      } catch (err) {
        // Seat gone (round over, grace expired) — normal lobby flow.
        Rest.log('info', `resume failed: ${(err as Error)?.message ?? err}`);
      }
    }
    this.scene.start('LobbyScene');
  }
}
